import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=0f462362&scoped=true&"
import script from "./main-header.vue?vue&type=script&lang=js&"
export * from "./main-header.vue?vue&type=script&lang=js&"
import style0 from "./styles/main-header.scss?vue&type=style&index=0&id=0f462362&scoped=true&lang=scss&"
import style1 from "./main-header.vue?vue&type=style&index=1&id=0f462362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f462362",
  null
  
)

component.options.__file = "main-header.vue"
export default component.exports